/* eslint-disable max-len */
export const APP_NAME = 'BT Business app';
export const ANALYTIC_ALT_TEXT_GOOGLE_PLAY_BTN = 'Get it on Google Play';
export const ANALYTIC_ALT_TEXT_APP_STORE_BTN = 'Download on the app store';
